import type {
  ComponentSize,
  ComponentVariant,
} from '../../../types/component.type';

export const baseAlertClasses = [
  'flex',
  'items-center',
  'gap-2',
  'rounded-lg',
  'transition-all',
  'duration-200',
];

export const alertSizeClasses: Record<NonNullable<ComponentSize>, string> = {
  '2xs': 'px-2 py-1',
  xs: 'px-2 py-1.5',
  sm: 'px-3 py-2',
  md: 'px-4 py-3',
  lg: 'px-6 py-4',
};

export const alertTextSizeClasses: Record<
  NonNullable<ComponentSize>,
  string
> = {
  '2xs': 'text-xs',
  xs: 'text-xs',
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-lg',
};

export const alertFilledClasses: Record<
  NonNullable<ComponentVariant>,
  string
> = {
  primary: 'bg-primary-500 text-white',
  secondary: 'bg-secondary-500 text-white',
  danger: 'bg-danger-500 text-white',
  warning: 'bg-warning-500 text-white',
  neutral: 'bg-neutral-500 text-white',
  success: 'bg-success-500 text-white',
  info: 'bg-info-500 text-white',
  whatsapp: 'bg-whatsapp-500 text-white',
  call: 'bg-call-500 text-white',
  email: 'bg-email-500 text-white',
};

export const alertSoftClasses: Record<NonNullable<ComponentVariant>, string> = {
  primary: 'bg-primary-50 text-primary-700',
  secondary: 'bg-secondary-50 text-secondary-700',
  danger: 'bg-danger-50 text-danger-700',
  warning: 'bg-warning-50 text-warning-700',
  neutral: 'bg-neutral-50 text-neutral-700',
  success: 'bg-success-50 text-success-700',
  info: 'bg-info-50 text-info-700',
  whatsapp: 'bg-whatsapp-50 text-whatsapp-700',
  call: 'bg-call-50 text-call-700',
  email: 'bg-email-50 text-email-700',
};

export const alertOutlineClasses: Record<
  NonNullable<ComponentVariant>,
  string
> = {
  primary: 'bg-white text-primary-700 border border-primary-700',
  secondary: 'bg-white text-secondary-700 border border-secondary-700',
  danger: 'bg-white text-danger-700 border border-danger-700',
  warning: 'bg-white text-warning-700 border border-warning-700',
  neutral: 'bg-white text-neutral-700 border border-neutral-300',
  success: 'bg-white text-success-700 border border-success-700',
  info: 'bg-white text-info-700 border border-info-700',
  whatsapp: 'bg-white text-whatsapp-700 border border-whatsapp-700',
  call: 'bg-white text-call-700 border border-call-700',
  email: 'bg-white text-email-700 border border-email-700',
};

/** Borderless status text for compact surfaces. */
export const alertGhostClasses: Record<
  NonNullable<ComponentVariant>,
  string
> = {
  primary: 'bg-transparent text-primary-700',
  secondary: 'bg-transparent text-secondary-700',
  danger: 'bg-transparent text-danger-700',
  warning: 'bg-transparent text-warning-700',
  neutral: 'bg-transparent text-neutral-700',
  success: 'bg-transparent text-success-700',
  info: 'bg-transparent text-info-700',
  whatsapp: 'bg-transparent text-whatsapp-700',
  call: 'bg-transparent text-call-700',
  email: 'bg-transparent text-email-700',
};
